import { python } from '@codemirror/lang-python';

import { Code } from '@/components/Code/Code';
import { FiltersDisplay } from '@/components/FiltersDisplay/FiltersDisplay';

import { SamplingRateDisplay } from './ModelAndRuleDisplayComponents';

export const EvaluatorDetailsCodeView = (props: {
  evaluator_code: string;
  filter?: string;
  traceFilter?: string;
  treeFilter?: string;
  samplingRate?: number;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-end gap-2">
        {(props.filter != null ||
          props.traceFilter != null ||
          props.treeFilter != null) && (
          <FiltersDisplay
            filter={props.filter}
            traceFilter={props.traceFilter}
            treeFilter={props.treeFilter}
          />
        )}
        {props.samplingRate != null && (
          <SamplingRateDisplay samplingRate={props.samplingRate} />
        )}
      </div>
      <Code
        value={props.evaluator_code}
        omitMaxHeight
        readOnly
        language={python()}
      />
    </div>
  );
};
